export default __webpack_public_path__ + "assets/broken-link.svg";